export const DISTRICT_LOOKUP_UNAVAILABLE_CODE = "district_lookup_unavailable";

export const DISTRICT_LOOKUP_UNAVAILABLE_MESSAGE =
  "We use the U.S. Census address service to find your congressional district. It's temporarily unavailable — please try again in a moment.";

export const DISTRICT_LOOKUP_UNAVAILABLE_SKIP_SUFFIX =
  "Or tap Skip for now and add your address later in Account settings.";

export const DISTRICT_LOOKUP_FALLBACK_SUFFIX =
  'We\'ve switched you to "I Know My District" — pick your state and district to continue without an address.';

function withSuffix(base, { allowSkip, allowDistrictFallback }) {
  if (allowDistrictFallback) return `${base} ${DISTRICT_LOOKUP_FALLBACK_SUFFIX}`;
  if (allowSkip) return `${base} ${DISTRICT_LOOKUP_UNAVAILABLE_SKIP_SUFFIX}`;
  return base;
}

/**
 * @param {object|null|undefined} data — axios `response.data` or fetch error payload
 * @param {{ allowSkip?: boolean, allowDistrictFallback?: boolean }} [options]
 * @returns {string|null}
 */
export function getDistrictLookupErrorMessageFromPayload(
  data,
  { allowSkip = false, allowDistrictFallback = false } = {}
) {
  if (!data || data.code !== DISTRICT_LOOKUP_UNAVAILABLE_CODE) {
    return null;
  }

  return withSuffix(data.detail || DISTRICT_LOOKUP_UNAVAILABLE_MESSAGE, {
    allowSkip,
    allowDistrictFallback,
  });
}

/**
 * @param {import('axios').AxiosError|{ response?: { data?: object, status?: number }, data?: object }} err
 * @param {{ allowSkip?: boolean, allowDistrictFallback?: boolean }} [options]
 * @returns {string|null}
 */
export function getDistrictLookupErrorMessage(
  err,
  { allowSkip = false, allowDistrictFallback = false } = {}
) {
  const data = err?.response?.data ?? err?.data;
  const fromCode = getDistrictLookupErrorMessageFromPayload(data, {
    allowSkip,
    allowDistrictFallback,
  });
  if (fromCode) {
    return fromCode;
  }

  if (err?.response?.status === 503 && data?.retryable) {
    return withSuffix(data?.detail || DISTRICT_LOOKUP_UNAVAILABLE_MESSAGE, {
      allowSkip,
      allowDistrictFallback,
    });
  }

  return null;
}

/** True when the failure came from the Census address lookup being unavailable. */
export function isDistrictLookupUnavailable(err) {
  return getDistrictLookupErrorMessage(err) !== null;
}
